import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Home, Crown, Mountain, Sparkles } from "lucide-react";
import { openAppStore } from "../lib/appStores";
import { isBoyGroupContestOpen } from "../lib/boyGroupLaunch";

const ACCENT = "#F5A623";

// Shared left rail for the landing page, competitions, and legal/info pages.
// Desktop (md+) only — pair it with `MobileHeader` for narrow screens and an
// `md:pl-60` content offset. The website does not offer login; the app does.
export default function Sidebar() {
  return (
    <aside className="fixed inset-y-0 left-0 z-40 hidden w-60 flex-col border-r border-white/10 bg-black px-3 py-5 md:flex">
      <Link to="/" className="mb-8 px-2">
        <img
          src="/images/pagent-word-logo.png"
          alt="Pagent"
          className="h-8 w-auto"
        />
      </Link>

      <nav className="flex flex-col gap-1">
        <RailLink to="/" end icon={Home} label="Home" />
        <RailLink to="/girlgroup" icon={Crown} label="Girl Group" />
        {isBoyGroupContestOpen() ? (
          <RailLink to="/boygroup" icon={Mountain} label="Boy Group" />
        ) : null}
        <RailLink to="/updates" icon={Sparkles} label="Patch updates" />
      </nav>

      <div className="mt-auto space-y-4 px-1">
        <button
          type="button"
          onClick={openAppStore}
          className="block w-full rounded-full px-5 py-2.5 text-center text-sm font-semibold text-black transition-opacity hover:opacity-90"
          style={{ backgroundColor: ACCENT }}
        >
          Get the app
        </button>

        <nav className="flex flex-wrap gap-x-3 gap-y-1 px-2 text-xs text-white/40">
          <Link to="/terms" className="hover:text-white/70">
            Terms
          </Link>
          <Link to="/privacy" className="hover:text-white/70">
            Privacy
          </Link>
          <Link to="/faq" className="hover:text-white/70">
            FAQ
          </Link>
          <Link to="/updates" className="hover:text-white/70">
            Patch updates
          </Link>
          <Link to="/support" className="hover:text-white/70">
            Support
          </Link>
        </nav>
      </div>
    </aside>
  );
}

function RailLink({ to, icon: Icon, label, end = false }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `flex items-center gap-3 rounded-xl px-3 py-2.5 text-base font-semibold transition-colors ${
          isActive
            ? "bg-white/10 text-white"
            : "text-white/70 hover:bg-white/5 hover:text-white"
        }`
      }
    >
      <Icon className="h-6 w-6 shrink-0" />
      <span>{label}</span>
    </NavLink>
  );
}

// Compact top bar shown on mobile (where the rail is hidden).
export function MobileHeader() {
  return (
    <header className="flex shrink-0 items-center justify-between px-5 py-3 md:hidden">
      <Link to="/">
        <img
          src="/images/pagent-word-logo.png"
          alt="Pagent"
          className="h-7 w-auto"
        />
      </Link>
      <button
        type="button"
        onClick={openAppStore}
        className="rounded-full px-5 py-2 text-sm font-semibold text-black transition-opacity hover:opacity-90"
        style={{ backgroundColor: ACCENT }}
      >
        Get the app
      </button>
    </header>
  );
}
